import React from 'react';
import { makeStyles } from 'tss-react/mui';

const CommentSkeleton = () => {
  const { classes } = useStyles();
  return <div className={classes.container} />;
};

const useStyles = makeStyles()(theme => ({
  container: {
    animation: `$skeleton-loading 2s linear infinite alternate`,
    width: '100%',
    minHeight: 109,
    backgroundColor: '#FFFFFF17',
    borderRadius: theme.spacing(0.5),
  },
  '@keyframes skeleton-loading': {
    '0%': {
      opacity: 1,
    },
    '50%': {
      opacity: 0.4,
    },
    '100%': {
      opacity: 1,
    },
  },
}));

export default CommentSkeleton;
